import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FlowRecipientsComponent} from './flow-recipients/flow-recipients.component';
import {MessageRecipientsComponent} from './message-recipients/message-recipients.component';
import { TaskAttribute } from '../create-task/create-task.type';

@Component({
   selector: 'app-mail-flow',
   templateUrl: './mail-flow.component.html',
   styleUrls: ['./mail-flow.component.css']
})
export class MailFlowComponent {
   @Input() typeName: string;
   @Input() taskAttribute: TaskAttribute;
   @Input() show = true;
   @Output() workflowIdChange = new EventEmitter<any>();
   @ViewChild(FlowRecipientsComponent, { static: true })
   public flowRecipient;

   @ViewChild(MessageRecipientsComponent)
   public messageRecipient;

   constructor() {
      // This is intentional.
   }

   onFlowChange(id) {
      this.workflowIdChange.emit(id);
   }

}
